export default __webpack_public_path__ + "static/eclipse_hero_background-8835f39353cbd558c75602643c459dd4.svg";